export default __webpack_public_path__ + "static/media/summary.43126d18.svg";